const searchTransactionsData = [
    {
        id: 1,
        title: "Status",
        content : [
            {
                field: 'Any',
                checked: 'checked'
            },
            {
                field: 'Confirming'
            },
            {
                field: 'Waiting for payment'
            },
            {
                field: 'Paid'
            },
            {
                field: 'Delivered'
            },
            {
                field: 'Canceled'
            },
        ]
    },
    {
        id: 2,
        title: "Tags",
        content : [
            {
                field: 'Any',
                checked: 'checked'
            },
            {
                field: 'Minimal Wear'
            },
            {
                field: 'Factory New'
            },
            {
                field: 'Field-Tested'
            },
            {
                field: 'Well-Worn'
            },
            {
                field: 'Battle-Scarred'
            }
        ]
    },
    {
        id: 3,
        title: "Phase",
        content : [
            {
                field: 'Any',
                checked: 'checked'
            },
            {
                field: 'Phase 1'
            },
            {
                field: 'Phase 2'
            },
            {
                field: 'Phase 3'
            },
            {
                field: 'Phase 4'
            },
            {
                field: 'Sapphire'
            },
            {
                field: 'Ruby'
            },
            {
                field: 'Black Pearl'
            },
            {
                field: 'Emerald'
            },
        ]
    }
]

export default searchTransactionsData;
